import { dispatchAction } from '@ardoq/rxbeach';
import {
  showComponentOverviewDrawer,
  ShowComponentOverviewDrawerPayload,
} from 'componentOverview2025/actions';
import { trackingData } from 'tracking/trackPayload';

export const openComponentOverviewDrawer = (
  payload: ShowComponentOverviewDrawerPayload
) =>
  dispatchAction(
    showComponentOverviewDrawer({
      ...payload,
      [trackingData]: {
        event: 'Component Overview0 Opened as drawer',
        payload: {
          source: payload.trackingLocation,
          startTab: payload.startTab ?? 'overview',
          componentId: payload.componentId,
        },
      },
    })
  );
